import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BigSpinner from '@/assets/BigSpinner.svg'

export default /*#__PURE__*/_defineComponent({
  __name: 'Spinner',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BigSpinner), { class: "spinner" }))
}
}

})